<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="onClose()">
  <div class="relative w-full max-w-2xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-[0_24px_70px_rgba(15,23,42,0.25)] border border-slate-100/60 dark:border-slate-700 overflow-hidden animate-fade-in-up" (click)="$event.stopPropagation()">
    <div class="absolute top-0 left-[10%] w-[80%] h-1.5 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 rounded-b-full"></div>
    <div *ngIf="isLoading() || isSaving()" class="absolute inset-0 z-50 bg-white/70 dark:bg-slate-900/70 backdrop-blur-sm flex items-center justify-center">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="px-6 md:px-8 pt-8 pb-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <span class="w-11 h-11 rounded-2xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center">
          <span class="material-icons">door_front</span>
        </span>
        <div>
          <h2 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ isEdit ? 'แก้ไขประเภทประตู' : 'เพิ่มประเภทประตู' }}</h2>
          <p class="text-xs text-slate-400 mt-0.5">กำหนดข้อมูล Master ประเภทประตู</p>
        </div>
      </div>
      <button (click)="onClose()" class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 md:p-8 space-y-5 max-h-[70vh] overflow-y-auto custom-scrollbar">
      <div *ngIf="isEdit" class="flex items-center gap-2 px-4 py-3 rounded-2xl bg-slate-50 dark:bg-slate-800 text-xs text-slate-500">
        <span class="material-icons text-amber-500 text-[18px]">info</span>
        <span>ID: <b class="text-slate-700 dark:text-slate-200">{{ formData.id }}</b></span>
        <span class="mx-1 text-slate-300">•</span>
        <span>สร้างเมื่อ {{ formData.createDate | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-500 mb-2">ชื่อประเภทประตู <span class="text-rose-500">*</span></label>
        <div class="relative">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[19px]">label</span>
          <input [(ngModel)]="formData.name" placeholder="ระบุชื่อประเภทประตู"
            class="w-full pl-10 pr-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 focus:border-amber-300 transition-all" />
        </div>
      </div>

      <div *ngIf="isEdit" class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-800/40 p-4">
        <div class="font-bold text-[10px] text-slate-400 uppercase tracking-widest mb-3">ข้อมูลตรวจสอบ Odoo</div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs text-slate-500">
          <div>create_uid: <b>{{ formData.createUid ?? '—' }}</b></div>
          <div>write_uid: <b>{{ formData.writeUid ?? '—' }}</b></div>
          <div>create_date: <b>{{ formData.createDate | date:'dd/MM/yyyy HH:mm' }}</b></div>
          <div>write_date: <b>{{ formData.writeDate | date:'dd/MM/yyyy HH:mm' }}</b></div>
          <div>attachment_id: <b>{{ formData.messageMainAttachmentId ?? '—' }}</b></div>
          <div>update_by: <b>{{ formData.updateBy || '—' }}</b></div>
        </div>
      </div>
    </div>

    <div class="px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col-reverse sm:flex-row justify-between gap-3 bg-slate-50/50 dark:bg-slate-900/50">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
        <button (click)="onClose()" class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:bg-white dark:hover:bg-slate-800 transition-all cursor-pointer">ยกเลิก</button>
        <button (click)="onSave()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none disabled:opacity-50 transition-all cursor-pointer flex items-center justify-center gap-2">
          <span class="material-icons text-[18px]">save</span>{{ isSaving() ? 'กำลังบันทึก...' : 'บันทึกข้อมูล' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingGateType"
  [entityId]="itemId"
  title="ประวัติประเภทประตู"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
